import angular from 'angular';
import closureComponent from './closure.component';

export default angular.module('components.app.adverseEvent.closure', [])
  .component('closure', closureComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/adverse-event/closure/closure.module.js